export default "__VITE_ASSET__Ddb3QlyT__"